import type { ConfirmOptions } from "@/components/confirm";
import type { CustomJobStatus } from "@/modules/custom-jobs/domain/types";

export type CustomJobTransitionKey =
  | "confirm"
  | "start"
  | "mark_ready"
  | "complete"
  | "cancel";

export function getCustomJobTransitionConfirm(
  action: CustomJobTransitionKey,
  options?: { status?: CustomJobStatus },
): ConfirmOptions {
  switch (action) {
    case "confirm":
      return {
        title: "ຢືນຢັນງານສັ່ງເຮັດ?",
        description: "ຫຼັງຢືນຢັນ ງານຈະເຂົ້າຄິວລໍຖ້າເລີ່ມເຮັດ",
        actionText: "ຢືນຢັນ",
      };
    case "start":
      return {
        title: "ເລີ່ມເຮັດງານ?",
        description: "ລະບົບຈະຫັກສະຕັອກວັດຖຸດິບອັດຕະໂນມັດ",
        actionText: "ເລີ່ມເຮັດ",
      };
    case "mark_ready":
      return {
        title: "ພ້ອມໃຫ້ລູກຄ້າມາຮັບ?",
        description: "ງານເສັດແລ້ວ — ລໍຖ້າລູກຄ້າມາຮັບ ແລະ ຈ່າຍເງິນ",
        actionText: "ພ້ອມຮັບ",
      };
    case "complete":
      return {
        title: "ສົ່ງມອບ ແລະ ຮັບເງິນ?",
        description: "ບັນທຶກວ່າລູກຄ້າມາຮັບ ແລະ ຈ່າຍເງິນແລ້ວ",
        actionText: "ສົ່ງມອບ+ຮັບເງິນ",
      };
    case "cancel":
      return {
        title: "ຍົກເລີກງານສັ່ງເຮັດ?",
        description:
          options?.status === "in_progress" || options?.status === "ready"
            ? "ຍົກເລີກຫຼັງເລີ່ມເຮັດແລ້ວ — ສະຕັອກທີ່ໃຊ້ໄປຈະບໍ່ຄືນ"
            : "ຍົກເລີກແລ້ວຈະບໍ່ສາມາດກັບຄືນໄດ້",
        actionText: "ຍົກເລີກ",
        tone: "destructive",
        ActionProps: { variant: "destructive" },
      };
  }
}
